import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import DurationSelect from "../duration-select/duration-select.vue";
import { fmtMsg } from "commonui";
import { CommonLocale, ContentExposureLocale } from "@/locales/localeid";
import { Tooltip } from "ant-design-vue";
import { toSeconds } from "@/util/func";

export interface DurationSelectorProps {
	isEdit?: boolean;
	isAnyEdit?: boolean;
	start?: string;
	end?: string;
}

@Component({
	components: {
		DurationSelect,
		Tooltip
	}
})
export default class DurationSelectRange extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: false }) isAnyEdit!: boolean;
	@Prop({ default: false }) isRepExposureDuration!: boolean;
	@Prop({ default: "3:00" }) start!: string;
	@Prop({ default: "3:30" }) end!: string;
	@Prop({ default: false }) showTooltip!: boolean; // to all disable tooltip permanently
	@Prop({ default: "" }) methodology!: string;
	@Prop({ default: -1 }) sequence!: number;
	@Prop({ default: -1 }) totalExposures!: number;
	tooltipVisible = false; // for mouse over and leave
	locale = CommonLocale;

	$refs!: {
		content: HTMLDivElement;
	};

	get showError() {
		return moment(this.start, "mm:ss").isAfter(moment(this.end, "mm:ss"));
	}

	get showTime() {
		const isTimeNotZero = toSeconds(this.start) != 0 && toSeconds(this.end) != 0;

		if (this.isRepExposureDuration) {
			return true;
		}

		return isTimeNotZero;
	}

	get separatorClass() {
		return this.isEdit ? "duration-select-range-separator" : "duration-select-range-separator-readonly";
	}
	get contentExposureLocale() {
		return ContentExposureLocale;
	}

	get showSepratedTime() {
		return !this.isRepExposureDuration;
	}

	mounted() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.addEventListener("dblclick", this.onDoubleClick);
			parent.addEventListener("mouseenter", this.onMouseEnter);
			parent.addEventListener("mouseleave", this.onMouseLeave);
		}
	}

	beforeDestroy() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.removeEventListener("dblclick", this.onDoubleClick);
			parent.removeEventListener("mouseenter", this.onMouseEnter);
			parent.removeEventListener("mouseleave", this.onMouseLeave);
		}
	}

	onDoubleClick() {
		!this.isEdit && this.$emit("doubleClick");
	}

	onMouseEnter() {
		this.tooltipVisible = true;
	}

	onMouseLeave() {
		this.tooltipVisible = false;
	}

	onStartChange(value) {
		this.$emit("change", { start: value, end: this.end });
	}
	onEndChange(value) {
		this.$emit("change", { start: this.start, end: value });
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	get isSequenceValid() {
		return this.sequence > 0 && this.sequence <= this.totalExposures;
	}

	getCurrentSequence() {
		return this.sequence;
	}
}
